import { queryQRCodeDetails, queryTableDetails } from "@/interface/table";
import { IQRCodeDetailData, ITable } from "@/types/table-types";

export const getTableAndQRCodeDetails = async (businessID: string, qrCodeId: string): Promise<{ tableDetails: ITable | undefined, qrCodeDetails: IQRCodeDetailData | undefined }> => {
  const qrCodeDetails = await queryQRCodeDetails(businessID, qrCodeId);
  if (qrCodeDetails && qrCodeDetails.status === 'bound' && qrCodeDetails.table_id) {
    const tableDetails = await queryTableDetails(businessID, `${qrCodeDetails.table_id}`);
    return { tableDetails, qrCodeDetails };
  }

  return { tableDetails: undefined, qrCodeDetails };
};